import type { ResourceLibraryItemBase } from './resourceLibraryItems';

export type SortOrder = 'latest' | 'oldest' | 'relevance';

export function isSortOrder(value: any): value is SortOrder {
    return value === 'latest' || value === 'oldest' || value === 'relevance';
}

export type SortableProps = Extract<
    keyof ResourceLibraryItemBase,
    'publicationDate' | 'lastModificationDate'
>;
